import { useState } from "react";
import { Link } from "react-router-dom";
import { getHot } from "@/utils/catalog";
import type { CatalogType } from "@/types/catalog";

const tabs: { type: CatalogType; label: string }[] = [
  { type: "movie", label: "电影" },
  { type: "tv", label: "电视剧" },
  { type: "variety", label: "综艺" },
];

export default function HotRanking() {
  const [active, setActive] = useState<CatalogType>("movie");
  const items = getHot(active, 6);

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-7 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 leading-tight">
              热门推荐
            </h2>
            <p className="mt-1 text-sm text-foreground-500">根据站内热度为你精选</p>
          </div>
        </div>
        <div className="inline-flex bg-background-200/70 rounded-full px-1 py-1 self-start">
          {tabs.map((tab) => (
            <button
              key={tab.type}
              onClick={() => setActive(tab.type)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                active === tab.type
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-2">
        {items.map((item, idx) => (
          <Link
            key={item.id}
            to={`/detail/${item.id}`}
            className="group flex items-center gap-4 p-3 rounded-lg hover:bg-background-50 transition-colors cursor-pointer"
          >
            <span
              className={`w-8 text-center text-xl font-black shrink-0 ${
                idx < 3 ? "text-primary-500" : "text-foreground-300"
              }`}
            >
              {idx + 1}
            </span>
            <div className="w-14 h-20 rounded-md overflow-hidden bg-background-200 shrink-0">
              <img
                src={item.poster}
                alt={`${item.title}海报`}
                title={`${item.title} - 热门推荐`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 truncate">
                {item.categoryLabel} · {item.year} · {item.genres.join("/")}
              </p>
              <p className="mt-1.5 text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-star-fill text-accent-500"></i>
                {item.rating}
                <span className="mx-1">·</span>
                <i className="ri-fire-line text-primary-500"></i>
                热度 {item.popularity}
              </p>
            </div>
            <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 text-xl shrink-0 transition-colors"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}